import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import Input from '../../../components/ui/Input';
import Select from '../../../components/ui/Select';

const RequestHistoryTable = () => {
  const [searchTerm, setSearchTerm] = useState('');
  const [statusFilter, setStatusFilter] = useState('');
  const [categoryFilter, setCategoryFilter] = useState('');
  const [dateRange, setDateRange] = useState('');

  const requests = [
    {
      id: "2024-015",
      title: "Problema de conectividade na rede",
      category: "Técnico",
      priority: "Alta",
      status: "Resolvida",
      createdDate: "25/10/2024",
      resolvedDate: "28/10/2024",
      assignedTo: "João Silva",
      description: "Intermitência na conexão de rede afetando produtividade"
    },
    {
      id: "2024-014",
      title: "Solicitação de novo usuário no sistema",
      category: "Suporte",
      priority: "Média",
      status: "Fechada",
      createdDate: "22/10/2024",
      resolvedDate: "24/10/2024",
      assignedTo: "Maria Santos",
      description: "Criação de acesso para novo colaborador"
    },
    {
      id: "2024-013",
      title: "Manutenção preventiva servidor",
      category: "Manutenção",
      priority: "Baixa",
      status: "Em Andamento",
      createdDate: "20/10/2024",
      resolvedDate: null,
      assignedTo: "Carlos Oliveira",
      description: "Manutenção programada do servidor principal"
    },
    {
      id: "2024-012",
      title: "Treinamento equipe nova funcionalidade",
      category: "Treinamento",
      priority: "Média",
      status: "Aguardando Cliente",
      createdDate: "18/10/2024",
      resolvedDate: null,
      assignedTo: "Ana Costa",
      description: "Capacitação da equipe para nova funcionalidade do sistema"
    },
    {
      id: "2024-011",
      title: "Instalação de equipamento adicional",
      category: "Instalação",
      priority: "Alta",
      status: "Aberta",
      createdDate: "15/10/2024",
      resolvedDate: null,
      assignedTo: null,
      description: "Instalação de servidor adicional para expansão"
    }
  ];

  const statusOptions = [
    { value: '', label: 'Todos os Status' },
    { value: 'Aberta', label: 'Aberta' },
    { value: 'Em Andamento', label: 'Em Andamento' },
    { value: 'Aguardando Cliente', label: 'Aguardando Cliente' },
    { value: 'Resolvida', label: 'Resolvida' },
    { value: 'Fechada', label: 'Fechada' }
  ];

  const categoryOptions = [
    { value: '', label: 'Todas as Categorias' },
    { value: 'Técnico', label: 'Técnico' },
    { value: 'Suporte', label: 'Suporte' },
    { value: 'Manutenção', label: 'Manutenção' },
    { value: 'Instalação', label: 'Instalação' },
    { value: 'Treinamento', label: 'Treinamento' }
  ];

  const dateRangeOptions = [
    { value: '', label: 'Todos os Períodos' },
    { value: '7days', label: 'Últimos 7 dias' },
    { value: '30days', label: 'Últimos 30 dias' },
    { value: '90days', label: 'Últimos 90 dias' },
    { value: 'year', label: 'Este ano' }
  ];

  const getStatusColor = (status) => {
    switch (status) {
      case 'Aberta':
        return 'text-warning bg-warning/10';
      case 'Em Andamento':
        return 'text-primary bg-primary/10';
      case 'Aguardando Cliente':
        return 'text-accent bg-accent/10';
      case 'Resolvida':
        return 'text-success bg-success/10';
      case 'Fechada':
        return 'text-muted-foreground bg-muted';
      default:
        return 'text-muted-foreground bg-muted';
    }
  };

  const getPriorityColor = (priority) => {
    switch (priority) {
      case 'Alta':
        return 'text-error';
      case 'Média':
        return 'text-warning';
      case 'Baixa':
        return 'text-success';
      default:
        return 'text-muted-foreground';
    }
  };

  const filteredRequests = requests?.filter(request => {
    const matchesSearch = request?.title?.toLowerCase()?.includes(searchTerm?.toLowerCase()) ||
                         request?.id?.toLowerCase()?.includes(searchTerm?.toLowerCase()) ||
                         request?.description?.toLowerCase()?.includes(searchTerm?.toLowerCase());
    const matchesStatus = !statusFilter || request?.status === statusFilter;
    const matchesCategory = !categoryFilter || request?.category === categoryFilter;
    
    return matchesSearch && matchesStatus && matchesCategory;
  });

  return (
    <div className="bg-card border border-border rounded-lg">
      {/* Header */}
      <div className="p-4 border-b border-border">
        <h3 className="font-semibold text-card-foreground mb-4">Histórico de Solicitações</h3>
        
        {/* Filters */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
          <Input
            placeholder="Buscar por título ou ID..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e?.target?.value)}
            className="w-full"
          />
          <Select
            placeholder="Status"
            options={statusOptions}
            value={statusFilter}
            onChange={setStatusFilter}
          />
          <Select
            placeholder="Categoria"
            options={categoryOptions}
            value={categoryFilter}
            onChange={setCategoryFilter}
          />
          <Select
            placeholder="Período"
            options={dateRangeOptions}
            value={dateRange}
            onChange={setDateRange}
          />
        </div>
      </div>
      {/* Table */}
      <div className="overflow-x-auto">
        <table className="w-full">
          <thead className="bg-muted/50">
            <tr>
              <th className="text-left p-4 font-medium text-muted-foreground">ID</th>
              <th className="text-left p-4 font-medium text-muted-foreground">Título</th>
              <th className="text-left p-4 font-medium text-muted-foreground">Categoria</th>
              <th className="text-left p-4 font-medium text-muted-foreground">Prioridade</th>
              <th className="text-left p-4 font-medium text-muted-foreground">Status</th>
              <th className="text-left p-4 font-medium text-muted-foreground">Criada em</th>
              <th className="text-left p-4 font-medium text-muted-foreground">Responsável</th>
              <th className="text-left p-4 font-medium text-muted-foreground">Ações</th>
            </tr>
          </thead>
          <tbody>
            {filteredRequests?.map((request) => (
              <tr key={request?.id} className="border-b border-border hover:bg-muted/30 transition-colors">
                <td className="p-4">
                  <span className="font-mono text-sm text-card-foreground">
                    #{request?.id}
                  </span>
                </td>
                <td className="p-4">
                  <div>
                    <p className="font-medium text-card-foreground">{request?.title}</p>
                    <p className="text-sm text-muted-foreground truncate max-w-xs">
                      {request?.description}
                    </p>
                  </div>
                </td>
                <td className="p-4">
                  <span className="text-sm text-muted-foreground">{request?.category}</span>
                </td>
                <td className="p-4">
                  <span className={`text-sm font-medium ${getPriorityColor(request?.priority)}`}>
                    {request?.priority}
                  </span>
                </td>
                <td className="p-4">
                  <span className={`px-2 py-1 rounded-full text-xs font-medium ${getStatusColor(request?.status)}`}>
                    {request?.status}
                  </span>
                </td>
                <td className="p-4">
                  <span className="text-sm text-muted-foreground">{request?.createdDate}</span>
                </td>
                <td className="p-4">
                  {request?.assignedTo ? (
                    <div className="flex items-center space-x-2">
                      <div className="w-6 h-6 bg-primary rounded-full flex items-center justify-center">
                        <Icon name="User" size={12} color="white" />
                      </div>
                      <span className="text-sm text-muted-foreground">{request?.assignedTo}</span>
                    </div>
                  ) : (
                    <span className="text-sm text-muted-foreground">Não atribuído</span>
                  )}
                </td>
                <td className="p-4">
                  <div className="flex items-center space-x-2">
                    <Button
                      variant="ghost"
                      size="sm"
                      iconName="Eye"
                    >
                      Ver
                    </Button>
                    <Button
                      variant="ghost"
                      size="sm"
                      iconName="MessageSquare"
                    >
                      Chat
                    </Button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      {/* Empty State */}
      {filteredRequests?.length === 0 && (
        <div className="p-8 text-center">
          <Icon name="Search" size={32} className="mx-auto mb-3 text-muted-foreground opacity-50" />
          <p className="text-muted-foreground">
            Nenhuma solicitação encontrada com os filtros aplicados
          </p>
        </div>
      )}
      {/* Pagination */}
      {filteredRequests?.length > 0 && (
        <div className="p-4 border-t border-border flex items-center justify-between">
          <p className="text-sm text-muted-foreground">
            Mostrando {filteredRequests?.length} de {requests?.length} solicitações
          </p>
          <div className="flex items-center space-x-2">
            <Button variant="outline" size="sm" disabled>
              <Icon name="ChevronLeft" size={16} />
            </Button>
            <span className="px-3 py-1 bg-primary text-primary-foreground rounded text-sm">1</span>
            <Button variant="outline" size="sm" disabled>
              <Icon name="ChevronRight" size={16} />
            </Button>
          </div>
        </div>
      )}
    </div>
  );
};

export default RequestHistoryTable;